import { createBrowserRouter } from 'react-router-dom';
import { RequireAuth } from './guards/RequireAuth';
import { RequireRole } from './guards/RequireRole';
import { DefaultLanding } from './DefaultLanding';
import { AppLayout } from '@/components/AppLayout';
import { LoginPage } from '@/features/auth/LoginPage';
import { LogoutPage } from '@/features/auth/LogoutPage';
import { ClientListPage } from '@/features/clients/ClientListPage';
import { ClientDetailPage } from '@/features/clients/ClientDetailPage';
import { SessionListPage } from '@/features/sessions/SessionListPage';
import { UploadPage } from '@/features/sessions/UploadPage';
import { ProcessingStatusPage } from '@/features/sessions/ProcessingStatusPage';
import { SectionConfigPage } from '@/features/sessions/SectionConfigPage';
import { FeedbackPage } from '@/features/sessions/FeedbackPage';
import { ReviewPage } from '@/features/review/ReviewPage';
import { ShadowValidationSessionDetailPage } from '@/features/shadow-validation/ShadowValidationSessionDetailPage';
import { ShadowValidationSessionListPage } from '@/features/shadow-validation/ShadowValidationSessionListPage';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { CoachManagementPage } from '@/features/admin/CoachManagementPage';
import { UserSettingsPage } from '@/features/settings/UserSettingsPage';
import { NotFoundPage } from '@/features/misc/NotFoundPage';

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/auth/logout', element: <LogoutPage /> },

  {
    path: '/',
    element: (
      <RequireAuth>
        <AppLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DefaultLanding /> },

      // クライアント一覧・詳細（全員）
      { path: 'clients', element: <ClientListPage /> },
      { path: 'clients/:clientId', element: <ClientDetailPage /> },
      { path: 'clients/:clientId/upload', element: <UploadPage /> },

      // セッション一覧（全員）
      { path: 'sessions', element: <SessionListPage /> },
      { path: 'sessions/:sessionId/status', element: <ProcessingStatusPage /> },
      { path: 'sessions/:sessionId/sections', element: <SectionConfigPage /> },
      { path: 'sessions/:sessionId/feedback', element: <FeedbackPage /> },
      { path: 'settings', element: <UserSettingsPage /> },

      // レビュー（feedbacker + admin）
      {
        element: <RequireRole feedbacker />,
        children: [
          { path: 'sessions/:sessionId/review', element: <ReviewPage /> },
        ],
      },

      // シャドウバリデーション確認（feedbacker + admin）
      {
        element: <RequireRole adminOrFeedbacker />,
        children: [
          { path: 'shadow-validation/sessions', element: <ShadowValidationSessionListPage /> },
          { path: 'shadow-validation/sessions/:sessionId', element: <ShadowValidationSessionDetailPage /> },
        ],
      },

      // タスクダッシュボード（feedbacker + admin）
      {
        element: <RequireRole feedbacker />,
        children: [
          { path: 'dashboard', element: <DashboardPage /> },
        ],
      },

      // ユーザー管理（admin）
      {
        element: <RequireRole admin />,
        children: [
          { path: 'admin/coaches', element: <CoachManagementPage /> },
        ],
      },
    ],
  },

  { path: '*', element: <NotFoundPage /> },
]);
